export default __webpack_public_path__ + "img/payment-online.9955822654bda673ba9e49d99cc74580.png";